"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rentalAssistanceTypes = exports.states = void 0;
exports.states = [
    "AL", "AK", "AZ", "AR", "CA", "CO", "CT", "DE", "DC", "FL", "GA", "HI",
    "ID", "IL", "IN", "IA", "KS", "KY", "LA", "ME", "MD", "MA", "MI", "MN",
    "MS", "MO", "MT", "NE", "NV", "NH", "NJ", "NM", "NY", "NC", "ND", "OH",
    "OK", "OR", "PA", "PR", "RI", "SC", "SD", "TN", "TX", "UT", "VT", "VA",
    "WA", "WV", "WI", "WY"
];
exports.rentalAssistanceTypes = ['section-8-hpd', 'section-8-nycha', 'city-fheps', 'vash-iss', 'tbi-waiver'];
